import { Typography } from "@material-ui/core"
import { HomePageCarStrip } from "api"
import NextLink from "common/bit/NextLink"
import { useEffect, useRef, useState } from "react"
import styled, { css } from "styled-components"

const StyledTitleDiv = styled.div<{ isShop: boolean }>`
  text-align: center;
  flex-shrink: 0;
  margin-top: 20px;
  ${(p) => p.theme.breakpoints.up("md")} {
    ${(p) => (!p.isShop ? "height: 117px;" : "height: 65px;")}
  }
  ${(p) => p.theme.breakpoints.down("sm")} {
    margin-bottom: 50px;
  }
  ${(p) =>
    p.isShop &&
    css`
      margin-top: 0 !important;
      margin-bottom: 0 !important;
      ${(p) => p.theme.breakpoints.down("sm")} {
        p {
          font-size: 24px;
        }
      }
    `}
`
const StyledWrapperText = styled.div`
  max-width: calc(100vw - 20px);
  width: 100%;
  overflow: hidden;
`

const StyledTitle = styled(Typography).attrs({
  variant: "body1",
})<{ $fontSize: number }>`
  width: max-content;
  font-size: 32px;
  font-size: ${(p) => p.$fontSize}px;
  margin: 0 auto;
  height: 45px;
  letter-spacing: 0.06em;
  font-weight: 400;
  ${(p) => p.theme.breakpoints.up("md")} {
    font-size: 32px;
  }
`

const StyledComingSoonText = styled(Typography).attrs({
  variant: "h1",
  component: "h2",
})`
  color: ${(p) => p.theme.colors.mazdaRed};
  height: 40px;
`

const StyledText = styled(Typography).attrs({
  variant: "body1",
})`
  font-size: 20px;
  height: 32px;
  letter-spacing: 0.08em;
`

type SwiperTopTextProps = {
  carData: HomePageCarStrip
  carLink: string
  isShop?: boolean
}

interface SwiperTopTextContentProps {
  carData: HomePageCarStrip
  fontSize: number
  textRef: React.RefObject<HTMLSpanElement>
  isShop?: boolean
}

const SwiperTopTextContent: React.FC<SwiperTopTextContentProps> = ({
  carData,
  fontSize,
  textRef,
  isShop,
}) => (
  <>
    {carData?.carState === "Future" && (
      <StyledComingSoonText>COMING SOON</StyledComingSoonText>
    )}
    <StyledWrapperText>
      <StyledTitle ref={textRef} $fontSize={fontSize}>
        {carData?.name}
      </StyledTitle>
    </StyledWrapperText>
    {!isShop && <StyledText>{carData?.secondaryTitle}</StyledText>}
  </>
)

const SwiperTopText = ({ carData, carLink, isShop }: SwiperTopTextProps) => {
  const [fontSize, setFontSize] = useState(32)
  const textRef = useRef(null)

  useEffect(() => {
    const text = textRef.current
    const textRect = text.getClientRects()[0]
    const textWidth = textRect.width
    const elementWidth = text.parentElement.offsetWidth
    if (textWidth >= elementWidth) {
      //text is more than one line
      //adjust the font size for it to fit in one line and not overflow
      const fontSize = (elementWidth / textWidth) * 32
      setFontSize(fontSize)
    } else {
      setFontSize(32)
    }
  }, [carData.name])

  return (
    <StyledTitleDiv role="heading" aria-level={2} isShop={isShop}>
      {carLink ? (
        <NextLink href={carLink}>
          <SwiperTopTextContent
            carData={carData}
            fontSize={fontSize}
            textRef={textRef}
            isShop={isShop}
          />
        </NextLink>
      ) : (
        <SwiperTopTextContent
          carData={carData}
          fontSize={fontSize}
          textRef={textRef}
          isShop={isShop}
        />
      )}
    </StyledTitleDiv>
  )
}

export default SwiperTopText
